import styled from 'styled-components';

const Container = styled.div`
  & > div {
    justify-content: space-between;
  }
`;

export { Container };
